module.exports = __webpack_public_path__ + "img/profile-pic-sleepy.78edb15a.jpg";